<template>
  <div
    class="modal fade fill-in disable-scroll mt-10"
    id="modal"
    tabindex="-1"
    role="dialog"
    aria-hidden="false"
  >
    <div class="modal-dialog modal-confirm modal-lebar modal-xl">
      <div v-if="is_loading" class="modal-content">
        <div class="bg-white rounded py-5 w-100 shade">
          <loader_component />
        </div>
      </div>
      <div v-else class="modal-content">
        <div
          v-if="post != null"
          class="modal-content-wrapper mt-5 shade bg-white"
        >
          <div class="modal-content shade" style="height: 20rem !important">
            <div
              class="modal-header pt-1 pb-0 d-flex bg-white rounded-top"
              style="height: 2rem"
            >
              <div
                class="shade ml-auto clickable hoverable bg-white"
                style="
                  margin-right: -30px;
                  margin-top: -15px;
                  height: 2rem;
                  width: 2rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <i
                  class="bi bi-x"
                  style="font-size: 30px"
                  data-dismiss="modal"
                  @click.prevent="closeModal"
                ></i>
              </div>
            </div>
            <div class="modal-body bg-white pt-0 pb-0">
              <div class="row">
                <div class="col-md-6">
                  <div class="d-flex">
                    <div
                      v-if="
                        post.source == 'media_cetak' ||
                          post.source == 'media_tv' ||
                          post.source == 'news'
                      "
                      class="btn-group"
                    >
                      <button
                        class="btn btn-sm"
                        :class="is_statement ? 'btn-light' : 'btn-success'"
                        @click="is_statement = false"
                      >
                        {{ post.source == "media_tv" ? "Video" : "Image" }}
                      </button>
                      <button
                        class="btn btn-sm"
                        :class="is_statement ? 'btn-success' : 'btn-light'"
                        @click="is_statement = true"
                      >
                        Statement
                      </button>
                    </div>
                    <button
                      @click="downloadImage()"
                      v-if="post.source == 'media_cetak'"
                      class="ml-2 btn btn-sm btn-success d-flex align-items-center"
                    >
                      <i
                        class="bi bi-download mr-1 mt-1"
                        aria-hidden="true"
                      ></i>
                      <span>Download Image</span>
                    </button>
                  </div>
                  <div class="avatar" v-if="!is_statement">
                    <div
                      v-if="
                        post.source == 'media_cetak' ||
                          (post.source == 'news' && post.thumbnail) ||
                          post.in_medias != null
                      "
                    >
                      <button
                        class="btn btn-sm btn-complete"
                        style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          margin-right: 5.5rem;
                          margin-bottom: 1.5rem;
                        "
                        @click="zoomOut"
                      >
                        <i class="bi bi-zoom-out"></i>
                      </button>
                      <button
                        class="btn btn-sm btn-complete"
                        style="
                          position: absolute;
                          right: 0;
                          bottom: 0;
                          margin-right: 3rem;
                          margin-bottom: 1.5rem;
                        "
                        @click="zoomIn"
                      >
                        <i class="bi bi-zoom-in"></i>
                      </button>
                    </div>
                    <div
                      v-if="
                        post.source == 'media_tv' || post.source == 'youtube'
                      "
                    >
                      <div
                        v-if="post.source == 'youtube'"
                        style="width: 30rem !important"
                      >
                        <span style="opacity: 0">{{ post.source }}</span>
                        <video-embed :src="post.url"></video-embed>
                        <span style="opacity: 0">{{ post.source }}</span>
                      </div>
                      <div v-else>
                        <video
                          @error="imgError"
                          style="width: 100%"
                          controls=""
                          :src="file_source"
                          muted
                        >
                          Your browser does not support HTML5 video.
                        </video>
                      </div>
                    </div>
                    <div
                      class="scroller"
                      style="max-height: 27.5rem !important; max-width: 30rem"
                      v-else-if="post.source == 'media_cetak'"
                    >
                      <div
                        class="list-files"
                        v-if="Array.isArray(post.file_source)"
                      >
                        <img
                          v-for="(file, index) in post.file_source"
                          :id="'gambar' + index"
                          :key="index"
                          :src="file"
                          alt="Post Image"
                          @error="imgError"
                          width="100%"
                        />
                      </div>
                      <img
                        v-else
                        id="gambar"
                        :src="post.file_source"
                        alt="Post Image"
                        @error="imgError"
                        width="100%"
                      />
                    </div>
                    <div v-else-if="post.source == 'news' && post.thumbnail">
                      <div
                        class="scroller"
                        style="max-height: 27.5rem !important; max-width: 30rem"
                      >
                        <img
                          id="gambar"
                          :src="post.thumbnail"
                          alt="Post Image"
                          @error="imgError"
                          width="100%"
                        />
                      </div>
                    </div>
                    <div v-else>
                      <div
                        v-if="post.in_medias != null"
                        class="in-medias m-t-10"
                        id="media"
                      >
                        <div
                          v-for="(in_media, in_media_index) in post.in_medias"
                          :key="in_media_index"
                          class="post-img-wrapper scroller"
                          style="
                            max-height: 27.5rem !important;
                            max-width: 30rem;
                          "
                          align="center"
                        >
                          <img
                            id="gambar"
                            v-if="in_media.type == 'photo'"
                            :src="in_media.media_url_https"
                            style="width: 100%"
                          />
                        </div>
                      </div>
                      <div
                        class="scroller"
                        style="max-height: 27.5rem !important; max-width: 30rem"
                        v-else-if="post.photo != null"
                      >
                        <img
                          id="gambar"
                          :src="post.photo"
                          alt="Image Post"
                          @error="imgError"
                          style="width: 100%"
                        />
                      </div>
                      <div v-else class="source">
                        <i
                          v-if="post.source"
                          class="fa-3x"
                          :class="
                            sosmed_icon[post.source] + ' icon-' + post.source
                          "
                        />
                      </div>
                    </div>
                  </div>
                  <!-- statement -->
                  <div
                    v-else
                    class="scroller mt-3"
                    style="max-height: 27.5rem !important"
                  >
                    <loader_component v-if="is_statement_loading" />
                    <div
                      class="mt-2 mx-1"
                      v-if="
                        statement &&
                          statement.length > 0 &&
                          !is_statement_loading
                      "
                    >
                      <div
                        class="card card-default border p-l-15 p-r-15"
                        style="border-radius: 10px"
                        v-for="(q, index) in list_statement"
                        :key="index"
                      >
                        <div class="row post-content mt-2">
                          <div class="col-md-1 col-xs-12" align="center">
                            <div
                              class="user-pic"
                              style="
                                background-color: #17a2b8;
                                border-radius: 50%;
                              "
                            >
                              <img
                                alt="Profile Image"
                                src="/assets/img/profiles/default.jpg"
                                class="img-circle"
                                @error="imageUrlAlt"
                              />
                            </div>
                          </div>
                          <div class="col-md-11">
                            <div class="d-flex">
                              <div
                                v-if="q.speaker && q.speaker != null"
                                class="account-name h6"
                                style="width: 70%"
                              >
                                {{ q.speaker }}
                              </div>
                              <div class="ml-auto fs-12" style="width: 30%">
                                <div class="d-flex">
                                  <i
                                    class="bi bi-calendar-event mr-1 ml-auto"
                                  ></i>
                                  {{ dateindo(q.date.$date) }}
                                </div>
                              </div>
                            </div>
                            <div class="d-flex align-items-center">
                              <span
                                v-if="q.source == 'news'"
                                class="m-r-10 post-number"
                                title="Sumber"
                              >
                                <i class="bi bi-globe-americas" />
                                {{ q.account ? q.account : "Tidak Tercantum" }}
                              </span>

                              <span
                                v-if="q.source == 'media_cetak'"
                                class="m-r-10 post-number"
                                title="Sumber Media Cetak"
                              >
                                <i class="bi bi-newspaper" />
                                {{ q.account ? q.account : "Tidak Tercantum" }}
                              </span>

                              <span
                                v-if="q.source == 'media_tv'"
                                class="m-r-10 post-number"
                                title="Channel TV - Nama Program"
                              >
                                <i class="bi bi-tv" />
                                {{ q.account ? q.account : "Tidak Tercantum" }}
                              </span>
                              <div v-if="q.sentiment === 1" class="m-r-10">
                                <span class="label label-success">Positif</span>
                              </div>
                              <div
                                v-else-if="q.sentiment === -1"
                                class="m-r-10"
                              >
                                <span class="label label-danger">Negatif</span>
                              </div>
                              <div v-else-if="q.sentiment === 0" class="m-r-10">
                                <span class="label label-netral">Netral</span>
                              </div>
                            </div>
                            <p class="statement-text-content text-justify mt-2">
                              <span
                                class="statement-content"
                                v-html="writeStatement(q.quote)"
                              ></span>
                              <a
                                href="javascript:void(0)"
                                v-if="cekString(q.quote)"
                                @click="showFullContent($event, index)"
                              >
                                Selengkapnya</a
                              >
                            </p>
                          </div>
                        </div>
                      </div>
                      <center
                        v-if="load != statement.length && statement.length > 5"
                      >
                        <button
                          class="btn btn-primary d-flex"
                          @click="loadMore"
                        >
                          <i class="bi bi-arrow-down mt-1"></i>
                          <span class="ml-1">Lebih Banyak</span>
                        </button>
                      </center>
                    </div>
                    <div v-else class="alert alert-warning mt-2 mr-1">
                      <center>
                        <i class="bi bi-exclamation-circle mr-1"></i>
                        <strong>Mohon maaf!</strong> Statement tidak tersedia
                      </center>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="row pt-1">
                    <div class="col-md-2 col-xs-12" align="center">
                      <div class="user-pic">
                        <img
                          alt="Profile Image"
                          :data-src-retina="post | showPicture"
                          :data-src="post | showPicture"
                          :src="post | showPicture"
                          class="img-circle"
                          @error="imageUrlAlt"
                        />
                      </div>
                    </div>
                    <div class="col-md-10">
                      <h6 class="row">
                        <span
                          class="pull-left account-name col-9"
                          style="cursor: pointer !important"
                        >
                          <span v-if="post.source === 'twitter'">@</span>
                          <span v-html="post.account"> </span>
                          <span>{{
                            post.program ? " - " + post.program : ""
                          }}</span>
                        </span>
                        <div
                          class="pull-right fs-12 col-3"
                          style="margin-top: 2px !important"
                        ></div>
                        <div class="clearfix" />
                      </h6>

                      <div class="d-flex align-items-center post-meta p-t-1">
                        <!-- medsos -->
                        <div
                          v-if="sosmed_list.includes(post.source)"
                          class="engagement-detail"
                        >
                          <span
                            v-if="post.source == 'review'"
                            class="post-number"
                            title="Data Source"
                          >
                            <i
                              class="bi"
                              :class="
                                post.data_source == 'playstore'
                                  ? 'bi-android'
                                  : 'bi-apple'
                              "
                            ></i>
                            {{
                              post.data_source == "playstore"
                                ? "Play Store"
                                : "App Store"
                            }}
                          </span>
                          <span v-else class="post-number" title="Followers">
                            <i
                              :class="
                                sosmed_icon[post.source] +
                                  ' icon-' +
                                  post.source
                              "
                            />
                            <span class="m-l-5 m-r-5">{{ post.source }}</span>
                            <span class="post-number" title="Followers">
                              <i class="bi bi-people" />
                              {{
                                post.followers
                                  ? post.followers
                                  : 0 | kmbFormatter
                              }}
                            </span>
                          </span>
                        </div>
                        <!-- medkon -->
                        <span
                          v-if="
                            !sosmed_list.includes(post.source) &&
                              post.source != 'media_tv' &&
                              post.source != 'media_cetak'
                          "
                          class="m-r-10 m-l-5 post-number"
                          title="Sumber"
                        >
                          <i class="bi bi-globe-americas" />

                          {{ post.source ? "Online News" : "Tidak Tercantum" }}
                        </span>

                        <span
                          v-if="post.source == 'media_cetak'"
                          class="m-r-10 m-l-5 post-number"
                          title="Sumber Media Cetak"
                        >
                          <i class="bi bi-newspaper" />
                          {{ post.source ? "Media Cetak" : "Tidak Tercantum" }}
                        </span>

                        <span
                          v-if="post.source == 'media_tv'"
                          class="m-r-10 m-l-5 post-number"
                          title="Channel TV - Nama Program"
                        >
                          <i class="bi bi-tv" />
                          {{ post.source ? "Media TV" : "Tidak Tercantum" }}
                        </span>

                        <!-- pers -->
                        <span
                          v-if="cekPers(post.id_account)"
                          class="bg-orange label text-white fs-10 ml-2"
                          >Pers</span
                        >
                        <!-- highlight -->
                        <div v-if="is_on_medmon">
                          <span
                            v-if="isAdmin"
                            @click="
                              post.highlight
                                ? unhighlightPost()
                                : highlightPost()
                            "
                            class="post-number m-r-10 ml-2"
                            title="Serupa dengan posting di highlight"
                            style="cursor: pointer"
                          >
                            <i
                              :class="
                                post.highlight
                                  ? 'text-warning bi bi-star-fill'
                                  : 'bi bi-star'
                              "
                            />
                          </span>
                          <span
                            v-else
                            class="post-number m-r-10 ml-2"
                            title="Serupa dengan posting di highlight"
                            style="cursor: pointer"
                          >
                            <i
                              :class="
                                post.highlight
                                  ? 'text-warning bi bi-star-fill'
                                  : 'bi bi-star'
                              "
                            />
                          </span>
                        </div>
                        <!-- redirect -->
                        <a
                          v-if="
                            post.source != 'media_cetak' &&
                              post.source != 'media_tv'
                          "
                          class="m-r-10 text-blue"
                          :href="post.url"
                          target="_blank"
                          ><i class="bi bi-box-arrow-up-right"
                        /></a>
                        <span
                          class="ml-auto mr-2"
                          v-if="isAdmin && is_on_medmon"
                          data-dismiss="modal"
                          aria-hidden="true"
                          style="color: #dc3545 !important; cursor: pointer"
                          @click="deletePost"
                        >
                          <i class="bi bi-trash" />
                        </span>
                        <span
                          class="d-flex align-items-center"
                          :class="is_on_medmon ? '' : 'ml-auto'"
                        >
                          <i class="bi bi-calendar-event mr-1" />
                          {{
                            post.source == "media_cetak" ||
                            post.source == "media_tv"
                              ? convertDate(post.date.$date)
                              : dateindo(post.date.$date)
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="row">
                      <!-- content -->
                      <div class="col-md-12" v-if="!is_edit">
                        <div
                          class="post-text-content mt-3 scroller"
                          style="max-height: 20rem !important"
                        >
                          <h6 v-html="post.title" class="text-justify"></h6>
                          <div
                            class="text-content"
                            style="word-break: break-word !important"
                            :id="'text-content'"
                            v-html="writeContent(post.content)"
                          ></div>
                          <div
                            v-if="post.source == 'instagram'"
                            style="opacity: 0"
                            class="my-0"
                          >
                            /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t
                            /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t /t/t/t
                          </div>
                          <!-- INSTAGRAM KOMENTAR -->
                          <div
                            v-if="
                              post.source == 'instagram' && comment_ig != false
                            "
                          >
                            <hr class="mb-3 mt-0" />
                            <div
                              class="font-weight-bolder d-flex align-items-center"
                            >
                              <i class="bi bi-chat-fill mr-1"></i> Komentar :
                            </div>
                            <loader_component v-if="is_comment_loading" />
                            <div v-else>
                              <div
                                id="comment"
                                class="mt-4"
                                v-if="check_comment == '1' && comment_ig"
                              >
                                <div v-for="(item, i) in data_comment" :key="i">
                                  <comment-instagram :data="item" />
                                </div>
                              </div>
                              <div
                                id="comment"
                                class="mt-4"
                                v-else-if="check_comment == '2' && comment_ig"
                              >
                                <div
                                  class="alert alert-warning mt-2 text-center"
                                  role="alert"
                                >
                                  Data komentar belum diperbaharui!
                                </div>
                              </div>
                              <div v-else>
                                <div
                                  class="alert alert-danger mt-2 text-center"
                                  role="alert"
                                >
                                  Tidak ada komentar dalam postingan ini!
                                </div>
                              </div>
                              <div
                                class="row mt-2"
                                v-if="
                                  post.engagement_detail.comment > 20 &&
                                    check_comment == '1' &&
                                    comment_ig
                                "
                              >
                                <div class="col-md-12">
                                  <a
                                    class="d-block text-center bg-success alert py-1 text-white my-2"
                                    :href="post.url"
                                    target="__blank"
                                  >
                                    <span class="text-white">
                                      Lihat lebih banyak
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12" v-if="is_edit">
                      <div
                        class="post-text-content mt-3 scroller"
                        style="max-height: 20rem !important"
                      >
                        <div class="form-group" v-if="post.title">
                          <input
                            type="text"
                            v-model="title"
                            required
                            class="form-control"
                          />
                        </div>
                        <div class="form-group">
                          <quil-editor
                            class="editor"
                            name="content"
                            v-model="content"
                            :options="editorOption"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- meta component -->
                    <div class="col-md-12 ml-2 mt-3">
                      <div class="row d-flex align-items-center">
                        <div
                          v-if="sosmed_list.includes(post.source)"
                          class="engagement-detail"
                        >
                          <span v-if="post.source != 'youtube'">
                            <span
                              v-for="(engagement,
                              e_index) in post.engagement_detail"
                              :key="e_index"
                              :title="post_attribute[e_index]"
                              class="m-r-5 post-number"
                            >
                              <i :class="post_meta[e_index]" />
                              {{ engagement ? engagement : 0 | kmbFormatter }}
                            </span>
                          </span>
                          <span v-else>
                            <span
                              v-for="(engagement,
                              e_index) in post.engagement_detail"
                              :key="e_index"
                              :title="youtube_attribute[e_index]"
                              class="m-r-5 post-number"
                            >
                              <i :class="youtube_meta[e_index]" />
                              {{ engagement ? engagement : 0 | kmbFormatter }}
                            </span>
                          </span>
                          <span
                            v-if="post.source == 'review'"
                            class="post-number m-r-5"
                            title="Score"
                          >
                            <i class="bi bi-star-fill" />
                            {{ post.score ? post.score : 0 | kmbFormatter }}
                          </span>
                          <span
                            v-if="post.source != 'review'"
                            class="post-number"
                            title="Reach"
                          >
                            <i class="bi bi-megaphone" />
                            {{ post.esmr ? post.esmr : 0 | kmbFormatter }}
                          </span>

                          <span
                            v-if="post.source != 'review'"
                            class="m-r-10 post-number"
                            title="Engagement"
                          >
                            <i class="bi bi-share-fill" />
                            {{
                              post.engagement_count
                                ? post.engagement_count
                                : 0 | kmbFormatter
                            }}
                          </span>
                        </div>
                        <!-- ad value -->
                        <!-- <span
                          v-if="
                            post.source == 'media_cetak' ||
                              post.source == 'media_tv'
                          "
                          class="m-r-10 post-number"
                          title="Ad Value"
                        >
                          <b>AD</b> IDR
                          {{
                            post.rate_fc > 0 && post.rate_fc > 0
                              ? post.rate_fc
                              : post.rate_fc > 0 && post.rate_bw == 0
                              ? post.rate_fc
                              : post.rate_fc == 0 && post.rate_bw > 0
                              ? post.rate_bw
                              : 0 | kmbFormatter
                          }}
                        </span> -->
                        <!-- ad value -->
                        <span
                          v-if="'ad_value' in post"
                          class="m-r-10 post-number"
                          title="Ad Value"
                        >
                          <b>AD</b> IDR
                          {{ post.ad_value ? post.ad_value : 0 | kmbFormatter }}
                        </span>
                        <!-- pr value -->
                        <span
                          v-if="'pr_value' in post"
                          class="m-r-10 post-number"
                          title="Public Relations Value"
                        >
                          <b>PR</b> IDR
                          {{ post.pr_value ? post.pr_value : 0 | kmbFormatter }}
                        </span>
                        <!-- amec value -->
                        <span
                          v-if="'amec' in post"
                          class="m-r-10 post-number"
                          title="Amec Value"
                        >
                          <b>a</b> {{ post.amec ? post.amec : 0 }}
                        </span>
                        <!-- page -->
                        <span
                          v-if="post.source == 'media_cetak'"
                          class="m-r-10 post-number"
                          title="Nomor Halaman"
                        >
                          <b>HAL</b> {{ post.page }}
                        </span>
                        <span
                          v-if="post.source == 'media_tv' && !is_edit"
                          class="m-r-10 post-number"
                          title="Jurnalis"
                        >
                          <i class="bi bi-person" />
                          {{
                            post.journalist
                              ? post.journalist
                              : "Tidak Tercantum"
                          }}
                        </span>
                        <div
                          class="input-group input-group-sm w-auto mr-2"
                          v-if="is_edit && post.source == 'media_tv'"
                        >
                          <div class="input-group-prepend">
                            <span
                              class="input-group-text"
                              id="inputGroup-sizing-sm"
                              ><i class="bi bi-person"
                            /></span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="jurnalis"
                            required
                          />
                        </div>
                        <span
                          v-if="post.source == 'media_cetak' && !is_edit"
                          class="m-r-10 post-number"
                          title="Jurnalis"
                        >
                          <i class="bi bi-person" />
                          {{
                            post.journalist
                              ? post.journalist
                              : "Tidak Tercantum"
                          }}
                        </span>
                        <div
                          class="input-group input-group-sm w-auto mr-2"
                          v-if="is_edit && post.source == 'media_cetak'"
                        >
                          <div class="input-group-prepend input-group-left">
                            <span
                              class="input-group-text"
                              id="inputGroup-sizing-sm"
                              ><i class="bi bi-person"
                            /></span>
                          </div>
                          <input
                            type="text"
                            class="form-control"
                            v-model="jurnalis"
                            required
                          />
                        </div>

                        <span
                          class="bg-danger label text-white p-t-1 p-b-1 fs-10 mr-1"
                          v-if="
                            hoax_detection && sosmed_list.includes(post.source)
                          "
                          >HOAX 30%</span
                        >
                        <span
                          class="bg-success label text-white p-t-1 p-b-1 fs-10 mr-1"
                          v-if="
                            hoax_detection && sosmed_list.includes(post.source)
                          "
                          >FAKTA 70%</span
                        >
                        <span
                          v-if="post.source == 'news' && post.author"
                          class="m-r-10 post-number"
                          title="Jurnalis"
                        >
                          <i class="bi bi-person" />
                          {{ post.author ? post.author : "Tidak Tercantum" }}
                        </span>
                        <!-- sentiment -->
                        <div class="m-r-10" v-if="isAdmin && is_on_medmon">
                          <select
                            name="sentiment"
                            :class="'select-sentimen sentimen' + post.sentiment"
                            @change="changeSentimen()"
                          >
                            <option value="1" :selected="post.sentiment == 1">
                              Positif
                            </option>
                            <option value="0" :selected="post.sentiment == 0">
                              Netral
                            </option>
                            <option value="-1" :selected="post.sentiment == -1">
                              Negatif
                            </option>
                          </select>
                        </div>
                        <div class="m-r-5" v-else>
                          <span
                            v-if="is_on_medmon"
                            class="label"
                            :class="
                              post.sentiment == 1
                                ? 'label-success'
                                : post.sentiment == 0
                                ? 'label-info'
                                : 'label-danger'
                            "
                            >{{
                              post.sentiment == 1
                                ? "Positif"
                                : post.sentiment == 0
                                ? "Netral"
                                : "Negatif"
                            }}</span
                          >
                        </div>
                        <!-- emotion -->
                        <div
                          class="input-group"
                          style="border: none !important; width: auto"
                          v-if="
                            'emotion' in post &&
                              isAdmin &&
                              is_on_medmon &&
                              post.source != 'news' &&
                              post.source != 'media_cetak' &&
                              post.source != 'media_tv'
                          "
                        >
                          <div class="input-group-prepend">
                            <label
                              :class="
                                'input-group-text bg-transparent emotion' +
                                  post.emotion
                              "
                              style="
                                border-top-left-radius: 3px;
                                border-bottom-left-radius: 3px;
                              "
                            >
                              <i
                                v-if="post.emotion == 0"
                                class="bi bi-emoji-neutral"
                                style="font-size: 12px; margin: -4px !important"
                                title="No Emotion"
                              />
                              <i
                                v-if="post.emotion == 1"
                                class="bi bi-emoji-smile text-success"
                                style="font-size: 12px; margin: -4px !important"
                                title="Senang"
                              />
                              <i
                                v-if="post.emotion == 2"
                                class="bi bi-emoji-dizzy"
                                style="
                                  font-size: 12px;
                                  margin: -4px !important;
                                  color: #ffc107;
                                "
                                title="Takut"
                              />
                              <i
                                v-if="post.emotion == 3"
                                class="bi bi-emoji-frown text-blue"
                                style="font-size: 12px; margin: -4px !important"
                                title="Sedih"
                              />
                              <i
                                v-if="post.emotion == 4"
                                class="bi bi-emoji-angry text-danger"
                                style="font-size: 12px; margin: -4px !important"
                                title="Marah"
                              />
                            </label>
                          </div>
                          <select
                            v-model="post.emotion"
                            :disabled="!is_on_medmon"
                            @change="changeEmotion(post.emotion)"
                            :class="'emotion' + post.emotion"
                            style="
                              border-top-right-radius: 3px;
                              border-bottom-right-radius: 3px;
                              border-top-left-radius: 0 !important;
                              border-bottom-left-radius: 0 !important;
                            "
                          >
                            <option value="0" :selected="post.emotion == 0">
                              No Emotion
                            </option>
                            <option value="1" :selected="post.emotion == 1">
                              Senang
                            </option>
                            <option value="2" :selected="post.emotion == 2">
                              Takut
                            </option>
                            <option value="3" :selected="post.emotion == 3">
                              Sedih
                            </option>
                            <option value="4" :selected="post.emotion == 4">
                              Marah
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <!-- share post -->
                    <div class="col-md-12">
                      <div class="d-flex mt-2">
                        <span class="mr-1">
                          <i class="bi bi-share"></i> Bagikan :
                        </span>
                        <ShareNetwork
                          :network="'whatsapp'"
                          :url="network_url"
                          :title="network_content"
                        >
                          <span class="mr-1 text-success hoverable clickable">
                            <i class="bi bi-whatsapp"></i>
                            <span class="font-weight-bolder"> Whatsapp </span>
                          </span>
                        </ShareNetwork>
                        <span>|</span>
                        <ShareNetwork
                          :network="'telegram'"
                          :url="network_url"
                          :title="network_content"
                        >
                          <span
                            class="ml-1 hoverable clickable"
                            style="color: #0088cc"
                          >
                            <i class="bi bi-telegram"></i>
                            <span class="font-weight-bolder"> Telegram </span>
                          </span>
                        </ShareNetwork>
                      </div>
                    </div>
                    <!-- topic -->
                    <div class="col-md-12 mt-2">
                      <div
                        v-if="post.source == 'twitter'"
                        class="d-flex align-items-center"
                      >
                        <span class="mr-1">Topik: </span>
                        <div v-if="post.topics">
                          <div
                            v-for="(t, tIndex) in post.topics"
                            :key="tIndex"
                            class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                          >
                            <span
                              v-if="isAdmin && !is_edit_socmed"
                              class="bi bi-x text-danger fa-lg"
                              @click="deleteTopik(t.$oid)"
                            >
                              &nbsp;</span
                            >
                            <span v-if="isAdmin && !is_edit_socmed">| &nbsp;</span>
                            <span>{{ showTopicName(t.$oid) }}</span>
                          </div>
                        </div>
                        <div class="in-reply mr-1" v-if="post.in_reply_to">
                          <div
                            class="in-reply-to"
                            v-if="post.in_reply_to.name && post.in_reply_to.id"
                          >
                            in reply to:
                            <a
                              :href="
                                'https://twitter.com/' +
                                  post.in_reply_to.name +
                                  '/status/' +
                                  post.in_reply_to.id
                              "
                              style="color: blue; opacity: 0.8 !important"
                              target="__blank"
                              >@{{ post.in_reply_to.name }}</a
                            >
                          </div>
                        </div>
                      </div>
                      <div
                        v-else-if="
                          post.source == 'facebook' ||
                            post.source == 'instagram' ||
                            post.source == 'youtube' ||
                            post.source == 'linkedin' ||
                            post.source == 'tiktok' ||
                            post.source == 'forum' ||
                            post.source == 'blog'
                        "
                        class="d-flex align-items-center"
                      >
                        <span class="mr-1">Topik: </span>
                        <div v-if="post.topics">
                          <div
                            v-for="(t, tIndex) in post.topics"
                            :key="tIndex"
                            class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                          >
                            <span
                              v-if="isAdmin && !is_edit_socmed"
                              class="bi bi-x text-danger fa-lg"
                              @click="deleteTopik(t.$oid)"
                            >
                              &nbsp;</span
                            >
                            <span v-if="isAdmin && !is_edit_socmed">| &nbsp;</span>
                            <span>{{ showTopicName(t.$oid) }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-else class="d-flex align-items-center">
                        <div v-if="is_on_medmon">
                          <span class="mr-1">Topik: </span>
                          <div v-if="post.topics">
                            <div
                              v-for="(t, tIndex) in post.topics"
                              :key="tIndex"
                              class="btn btn-xs btn-rounded btn-default fs-10 m-r-5"
                            >
                              <span
                                v-if="isAdmin && !is_edit"
                                class="bi bi-x text-danger fa-lg"
                                @click="deleteTopik(t.$oid)"
                              >
                                &nbsp;</span
                              >
                              <span v-if="isAdmin && !is_edit">| &nbsp;</span>
                              <span>{{ showTopicName(t.$oid) }}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="is_edit || is_edit_socmed"
                      class="col-md-12 mt-1"
                    >
                      <div class="form-group w-auto mr-1">
                        <multiselect
                          v-if="topic_options"
                          v-model="topik"
                          :options="topic_options"
                          :multiple="true"
                          group-values="topik"
                          group-label="group"
                          :group-select="true"
                          placeholder="Pilih topik"
                          track-by="id"
                          label="name"
                        >
                        </multiselect>
                      </div>
                    </div>
                    <div v-if="is_on_medmon" class="col-md-12 ">
                      <span class="d-flex">
                        <span
                          v-if="
                            (this.post.source == 'media_cetak' ||
                              this.post.source == 'media_tv' ||
                              this.post.source == 'news') &&
                              isAdmin
                          "
                          class="ml-auto"
                          :class="is_edit ? 'btn btn-danger' : 'text-success'"
                          style="cursor: pointer"
                          @click="editData"
                        >
                          <i v-if="!is_edit" class="bi bi-pencil-square" />
                          {{ is_edit ? "Batal" : "Edit" }}
                        </span>
                        <span
                          @click.prevent="saveStream"
                          v-if="is_edit"
                          class="btn btn-success ml-1 mr-1"
                        >
                          Simpan
                        </span>
                      </span>
                      <span class="d-flex">
                        <span
                          v-if="isAdmin && !isMedkon(this.post.source)"
                          class="ml-auto"
                          :class="
                            is_edit_socmed ? 'btn btn-danger' : 'text-success'
                          "
                          style="cursor: pointer"
                          @click="is_edit_socmed = !is_edit_socmed"
                        >
                          <i
                            v-if="!is_edit_socmed"
                            class="bi bi-pencil-square"
                          />
                          {{ is_edit_socmed ? "Batal" : "Edit" }}
                        </span>
                        <span
                          @click.prevent="saveStream"
                          v-if="is_edit_socmed"
                          class="btn btn-success ml-1 mr-1"
                        >
                          Simpan
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="clearfix" />
            <div class="modal-footer bg-white rounded-bottom" />
          </div>
        </div>
        <div
          v-else
          style="height: 10rem !important"
          class="modal-content-wrapper bg-white shade"
        >
          <div
            class="modal-header pt-1 pb-0 d-flex bg-white rounded-top"
            style="height: 2rem"
          >
            <div
              class="shade ml-auto clickable hoverable bg-white"
              style="
                margin-right: -30px;
                margin-top: -15px;
                height: 2rem;
                width: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
              "
            >
              <i
                class="bi bi-x"
                style="font-size: 30px"
                data-dismiss="modal"
                @click.prevent="closeModal"
              ></i>
            </div>
          </div>
          <div class="bg-white mt-3">
            <div class="alert alert-warning mx-5">
              <h5><center>Berita tidak tersedia</center></h5>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import gp from "@/plugins/generalPlugins.js";
import axios from "axios";
import swal from "sweetalert";
import { getTopicKeyword } from "@/models/topic.js";
import loader_component from "@/views/components/loader.vue";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Multiselect from "vue-multiselect";
import { quillEditor } from "vue-quill-editor";
import CommentInstagram from "@/views/components/mention/instagram_comment.vue";

var sosmed_icon = new Array();
sosmed_icon["facebook"] = "bi bi-facebook";
sosmed_icon["twitter"] = "bi bi-twitter";
sosmed_icon["youtube"] = "bi bi-youtube";
sosmed_icon["instagram"] = "bi bi-instagram";
sosmed_icon["news"] = "bi bi-globe-americas";
sosmed_icon["blog"] = "bi bi-rss";
sosmed_icon["forum"] = "bi bi-chat-dots-fill";
sosmed_icon["media_cetak"] = "bi bi-newspaper";
sosmed_icon["media_tv"] = "bi bi-tv";
sosmed_icon["linkedin"] = "bi bi-linkedin";
sosmed_icon["tiktok"] = "bi bi-tiktok";
sosmed_icon["review"] = "bi bi-phone";

var post_meta = [];
post_meta["comment"] = "bi bi-chat-fill";
post_meta["view"] = "bi bi-eye";
post_meta["rt"] = "bi bi-repeat";
post_meta["share"] = "bi bi-share";
post_meta["like"] = "bi bi-heart-fill";
post_meta["fav"] = "bi bi-heart-fill";
post_meta["play"] = "bi bi-play";

var youtube_meta = [];
youtube_meta["comment"] = "bi bi-chat-fill";
youtube_meta["view"] = "bi bi-eye";
youtube_meta["like"] = "bi bi-hand-thumbs-up";
youtube_meta["dislike"] = "bi bi-hand-thumbs-down";
youtube_meta["favorite"] = "bi bi-heart-fill";

var post_attribute = [];
post_attribute["fav"] = "Like";
post_attribute["like"] = "Like";
post_attribute["rt"] = "Retweet";
post_attribute["share"] = "Share";
post_attribute["comment"] = "Comment";
post_attribute["view"] = "View";
post_attribute["play"] = "Play";

var youtube_attribute = [];
youtube_attribute["favorite"] = "Favorite";
youtube_attribute["like"] = "Like";
youtube_attribute["dislike"] = "Dislike";
youtube_attribute["comment"] = "Comment";
youtube_attribute["view"] = "View";

export default {
  name: "modal_detail_post",
  components: {
    "quil-editor": quillEditor,
    Multiselect,
    loader_component,
    "comment-instagram": CommentInstagram,
  },
  props: {
    id_stream: String,
    index: Number,
    is_on_medmon: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
    props_data: {
      type: Object,
      default: function() {
        return {};
      },
    },
  },
  data() {
    return {
      network_url: window.location.origin,
      network_content:
        "Lihat apa yang Saya temukan di " + window.location.origin + " \n\n",
      post: null,
      data_comment: null,
      check_comment: "0",
      statement: null,
      list_statement: [],
      load: 5,
      stringLimit: 200,
      is_statement: false,
      topics: null,
      pers: null,
      keyword: null,
      title: "",
      content: "",
      jurnalis: "",
      topik: [],
      topik_s: {},
      topic_options: [],
      sosmed_icon: sosmed_icon,
      post_attribute: post_attribute,
      post_meta: post_meta,
      youtube_meta: youtube_meta,
      youtube_attribute: youtube_attribute,
      sosmed_list: [
        "facebook",
        "instagram",
        "twitter",
        "youtube",
        "linkedin",
        "tiktok",
        "review",
      ],
      hoax_detection:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
              .hoax_detection
          : 0,
      comment_ig:
        "features" in this.$store.getters.user.project.project_detail
          ? this.$store.getters.user.project.project_detail.features
              .ig_comment == 1
            ? true
            : false
          : false,
      tipe_project: this.$store.getters.user.project.project_detail.tipe,
      id_project: this.$store.getters.user.id_project,
      highlight_list: [],
      spaces_error: false,
      is_change: false,
      is_edit: false,
      is_edit_socmed: false,
      is_loading: true,
      editorOption: {
        modules: {
          toolbar: [["bold", "italic", "underline"]],
        },
      },
      is_data_null: false,
      is_statement_loading: false,
      is_comment_loading: false,
    };
  },
  methods: {
    isMedkon(source) {
      const medkon_list = ["news", "media_cetak", "media_tv", "radio"];
      if (medkon_list.includes(source)) {
        return true;
      }
      return false;
    },
    downloadImage() {
      for (var i = 0; i < this.post.file_source.length; i++) {
        setTimeout(
          function(path) {
            window.location = path;
          },
          200 + i * 200,
          this.post.file_source[i]
        );
      }
    },
    loadMore: function() {
      let limit = this.statement.length - this.load;
      if (limit < 5) {
        this.load += limit;
      } else {
        this.load += 5;
      }
      this.getItemLoad();
    },
    getItemLoad: function() {
      this.is_statement_loading = true;
      if (this.statement.length < 5) {
        this.list_statement = this.statement;
      } else {
        for (let i = 0; i < this.load; i++) {
          this.list_statement[i] = this.statement[i];
        }
      }
      this.is_statement_loading = false;
    },
    getStatement: function() {
      let self = this;
      if (
        self.post.source == "media_cetak" ||
        self.post.source == "media_tv" ||
        self.post.source == "news"
      ) {
        let api =
          process.env.VUE_APP_API_URL + "post-statements/" + this.id_stream;
        self.is_statement_loading = true;
        this.$http
          .get(api)
          .then(function(response) {
            if (response.status == 200 && response.data != null) {
              self.statement = response.data.statements;
              self.getItemLoad();
            }
          })
          .catch(function(err) {
            console.log(err);
          })
          .finally(function() {
            self.is_statement_loading = false;
          });
      }
    },
    getData: function(load) {
      let self = this;
      let api = process.env.VUE_APP_API_URL + "stream/" + this.id_stream;
      if (load) {
        self.is_loading = true;
      }
      if (this.is_on_medmon) {
        this.$http
          .get(api)
          .then(function(response) {
            if (response.status == 200 && response.data != null) {
              self.post = response.data;
              self.content = self.writeContent(response.data.content);
              self.getDataComment();
              self.getStatement();
              let akun = self.sosmed_list.includes(self.post.source)
                ? self.post.account
                : self.post.title;
              let title = self.post.source == "twitter" ? "@" + akun : akun;
              self.network_content += title + "\n";

              if (self.sosmed_list.includes(self.post.source)) {
                self.network_content +=
                  self.post.content.substring(0, 140) + "...\n";
              }

              if (self.post.source == "media_cetak") {
                if (self.is_on_medmon) {
                  self.network_content +=
                    window.location.origin +
                    "/view?id=" +
                    self.post._id.$oid +
                    "\n";
                } else {
                  self.network_content +=
                    window.location.origin +
                    "/view?id=" +
                    self.post._id.$oid +
                    "&archive_type=siputra \n";
                }
              } else if (self.post.source == "media_tv") {
                self.network_content +=
                  window.location.origin +
                  "/view?id=" +
                  self.post._id.$oid +
                  "\n";
              } else if (self.post.source == "news") {
                self.network_content +=
                  window.location.origin +
                  "/view?id=" +
                  self.post._id.$oid +
                  "\n";
              } else {
                self.network_content += self.post.url;
              }
              self.network_content += "\n\n";
              self.autoHighlight();
            } else {
              self.is_data_null = true;
            }
          })
          .catch(function() {
            self.is_data_null = true;
          })
          .finally(function() {
            self.is_loading = false;
          });
      } else {
        self.post = self.props_data;
        self.content = self.writeContent(self.props_data.content);
        self.getDataComment();
        self.getStatement();
        let akun = self.sosmed_list.includes(self.post.source)
          ? self.post.account
          : self.post.title;
        let title = self.post.source == "twitter" ? "@" + akun : akun;
        self.network_content += title + "\n";

        if (self.sosmed_list.includes(self.post.source)) {
          self.network_content += self.post.content.substring(0, 140) + "...\n";
        }

        if (self.post.source == "media_cetak") {
          if (self.is_on_medmon) {
            self.network_content +=
              window.location.origin + "/view?id=" + self.post._id.$oid + "\n";
          } else {
            self.network_content +=
              window.location.origin +
              "/view?id=" +
              self.post._id.$oid +
              "&archive_type=siputra \n";
          }
        } else if (self.post.source == "media_tv") {
          self.network_content +=
            window.location.origin + "/view?id=" + self.post._id.$oid + "\n";
        } else if (self.post.source == "news") {
          self.network_content +=
            window.location.origin + "/view?id=" + self.post._id.$oid + "\n";
        } else {
          self.network_content += self.post.url;
        }
        self.network_content += "\n\n";
        self.autoHighlight();
        self.is_loading = false;
      }
    },
    getPers: function() {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "pers";
      this.$http
        .get(api)
        .then(function(response) {
          if (response.status == 204) {
            self.pers = [];
          } else {
            self.pers = response.data;
          }
        })
        .catch(function() {
          self.pers = [];
        });
    },
    getTopics: function() {
      var self = this;
      let api = process.env.VUE_APP_API_URL + "list-topics/" + this.id_project;
      this.$http
        .get(api)
        .then(function(response) {
          if (response.status == 204) {
            self.topics = {};
          } else {
            self.topics = response.data;
          }
        })
        .catch(function() {
          self.topics = {};
        });
    },
    getDataComment: function() {
      if (this.comment_ig && this.post.source == "instagram") {
        this.is_comment_loading = true;
        let api =
          process.env.VUE_APP_API_URL +
          "v2/instagram/comment/" +
          this.post.id_origin;
        this.$http
          .get(api)
          .then((response) => {
            this.data_comment = [];
            this.data_comment = response.data.data;
            if (
              this.data_comment.length > 0 &&
              this.post.engagement_detail.comment > 0
            ) {
              this.check_comment = "1";
            } else if (
              this.data_comment.length == 0 &&
              this.post.engagement_detail.comment > 0
            ) {
              this.check_comment = "2";
            } else {
              this.check_comment = "0";
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.is_comment_loading = false;
          });
      }
    },
    zoomIn: function() {
      if (Array.isArray(this.post.file_source)) {
        for (let i = 0; i < this.post.file_source.length; i++) {
          var gambar = document.getElementById("gambar" + i);
          var currWidth = gambar.clientWidth;
          if (currWidth >= 1500) return false;
          else {
            gambar.style.width = currWidth + 100 + "px";
          }
        }
      } else {
        var gambar1 = document.getElementById("gambar");
        var currWidth1 = gambar1.clientWidth;
        if (currWidth1 >= 1500) return false;
        else {
          gambar1.style.width = currWidth1 + 100 + "px";
        }
      }
    },
    zoomOut: function() {
      if (Array.isArray(this.post.file_source)) {
        for (let i = 0; i < this.post.file_source.length; i++) {
          var gambar = document.getElementById("gambar" + i);
          var currWidth = gambar.clientWidth;
          if (currWidth <= 500) return false;
          else {
            gambar.style.width = currWidth - 100 + "px";
          }
        }
      } else {
        var gambar1 = document.getElementById("gambar");
        var currWidth1 = gambar1.clientWidth;
        if (currWidth1 <= 500) return false;
        else {
          gambar1.style.width = currWidth1 - 100 + "px";
        }
      }
    },
    closeModal: function(event) {
      var $trigger = $(".modal-lebar");
      if ($trigger !== event.target && !$trigger.has(event.target).length) {
        this.$parent.isShowModalDetail = false;
      }
      this.$parent.data[this.index] = this.post;
    },
    convertDate: function(tanggal) {
      return gp.convertDate(tanggal);
    },
    imageUrlAlt: function() {
      event.target.src = "/assets/img/profiles/default.png";
    },
    cekPers: function(_id) {
      if (this.pers != null) {
        return this.pers.includes(_id);
      } else {
        return false;
      }
    },
    dateindo: function(tanggal) {
      return gp.dateTimeID(tanggal);
    },
    showTopicName: function(_id) {
      if (this.topics != null) {
        for (let grup in this.topics.formed) {
          for (let topic in this.topics.formed[grup].topics) {
            if (_id == topic) {
              return this.topics.formed[grup].topics[topic];
            }
          }
        }
        if (_id in this.topics.socmed) {
          return this.topics.socmed[_id];
        } else {
          return "Topik Dihapus";
        }
      } else {
        return "Topik Dihapus";
      }
    },
    deleteTopik: function(id) {
      let self = this;
      let topics = [id];
      let api = process.env.VUE_APP_API_URL + "delete-stream-topic";
      let params = {
        _id: this.post._id.$oid,
        topics: topics,
      };

      axios.post(api, params).then(function(response) {
        if (response.status == 200) {
          self.getData(false);
          self.is_change = true;
        }
      });
    },
    getHighlight: function() {
      let api =
        process.env.VUE_APP_API_URL + "highlight-ids/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          this.highlight_list = response.data;
        })
        .catch((error) => {
          console.log(error);
          this.highlight_list = [];
        });
    },
    highlightPost: function() {
      this.post.highlight = true;
      let params = {
        _id: this.post._id.$oid,
      };

      let api = process.env.VUE_APP_API_URL + "highlight-add";
      this.$http.post(api, params).then((response) => {
        if (response.status == 200) {
          this.highlight_list.push({ $oid: params._id });
          this.is_change = true;
        }
      });
    },
    unhighlightPost: function() {
      let params = {
        _id: this.post._id.$oid,
      };
      let api = process.env.VUE_APP_API_URL + "highlight-remove";
      this.$http.post(api, params).then((response) => {
        if (response.status == 200) {
          this.post.highlight = false;
          this.getHighlight();
          this.is_change = true;
        }
      });
    },
    imgError: function() {
      event.target.src = "/assets/img/web/imgerror.png";
    },
    changeSentimen: function() {
      event.preventDefault();
      var tgt = event.target;
      let self = this;
      var newValue = $(tgt)[0].value;
      let params = {
        _id: this.post._id.$oid,
        sentiment: parseInt(newValue),
      };
      let api = process.env.VUE_APP_API_URL + "post-sentiment";
      axios.post(api, params).then(function(response) {
        if (response.status == 200) {
          self.is_change = true;
          self.post.updated_sentiment = 1;
          self.post.sentiment = parseInt(newValue);
          if ("updated_value" in response.data) {
            self.post.pr_value = response.data.updated_value.pr_value;
          }
          self.getData(false);
        }
      });
    },
    deletePost: function() {
      swal({
        title: "Apakah anda yakin?",
        text: "Akan menghapus posting ini.",
        icon: "warning",
        buttons: ["Tidak", "Ya"],
        dangerMode: true,
        className: "swal-custom",
      }).then((yess) => {
        this.$parent.isShowModalDetail = true;
        if (yess) {
          this.$parent.isShowModalDetail = false;
          let self = this;
          let params = {
            _id: this.post._id.$oid,
          };
          event.preventDefault();
          let api = process.env.VUE_APP_API_URL + "post-delete";
          axios.post(api, params).then(function(response) {
            if (response.status == 200) {
              self.$parent.$parent.getData();
              self.$parent.$parent.getFiltersData();
              self.$parent.$parent.getFiltersSentiment();
              self
                .$("body")
                .pgNotification({
                  style: "bar",
                  message:
                    '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Data berhasil dihapus!',
                  position: "top",
                  timeout: 5000,
                  type: "success",
                })
                .show();
            }
          });
        }
      });
    },
    changeEmotion: function(val) {
      let param = {
        _id: this.post._id.$oid,
        emotion: parseInt(val),
      };
      let api = process.env.VUE_APP_API_URL + "post-emotion";
      this.$http.post(api, param).then((response) => {
        if (response.status == 200) {
          this.is_change = true;
          this.post.emotion = val;
          this.post.updated_emotion = 1;
        }
      });
    },
    editData: function() {
      this.is_edit = !this.is_edit;
      if (this.is_edit) {
        if (this.post.title) {
          this.title = this.post.title;
        }
        if (
          this.post.source == "media_cetak" ||
          this.post.source == "media_tv"
        ) {
          this.jurnalis = this.post.journalist;
        }
      }
    },
    getTopic: function() {
      var self = this;
      let api =
        process.env.VUE_APP_API_URL + "display-topics/" + this.id_project;
      this.$http
        .get(api)
        .then((response) => {
          if (response.status == 200) {
            self.topik_s = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          self.loadTopic();
        });
    },
    loadTopic: function() {
      let topik = [];
      let tmp;
      let group_topic = [];

      for (let row in this.topik_s.formed) {
        tmp = {
          id: row,
          name: this.topik_s.formed[row],
        };
        topik.push(tmp);
      }
      if (this.isMedkon(this.post.source)) {
        group_topic.push({
          group: "Media Konvensional",
          topik: topik,
        });
      }

      topik = [];
      for (let row in this.topik_s.socmed) {
        tmp = {
          id: row,
          name: this.topik_s.socmed[row],
        };
        topik.push(tmp);
      }

      if (!this.isMedkon(this.post.source)) {
        group_topic.push({
          group: "Media Sosial",
          topik: topik,
        });
      }

      this.topic_options = group_topic;
    },
    markString: function(content, marked_word = []) {
      let kata = [];
      if ("q" in this.$route.query) {
        kata = this.$route.query.q;
        kata = gp.extractPhrase(kata);
      }
      if (marked_word.length > 0) {
        marked_word.forEach((word) => {
          word = gp.extractPhrase(word);
          if (
            word.every((w) => content.toLowerCase().includes(w.toLowerCase()))
          ) {
            word.forEach((w) => {
              w = w.trim();
              kata.push(w);
            });
          }
        });
      }
      kata = [...new Set(kata)];
      kata.forEach(function(word) {
        word = word.replaceAll('"', "");
        word = word.trim();
        let reg_exp = new RegExp("(\\b" + word + "\\b)", "gi");
        content = content.replace(
          reg_exp,
          ` <mark data-markjs="true"> ${word}  </mark> `
        );
      });
      return content;
    },
    saveStream: function() {
      if (this.isMedkon(this.post.source)) {
        if (this.title != "" && this.content != "") {
          let api = process.env.VUE_APP_API_URL + "update-stream";
          let data = {
            _id: this.post._id["$oid"],
            title: this.$sanitize(this.title),
            content: this.$sanitize(this.content),
          };
          if (
            this.post.source == "media_cetak" ||
            this.post.source == "media_tv"
          ) {
            data["journalist"] = this.$sanitize(this.jurnalis);
          }
          if (this.topik.length > 0) {
            let topicArray = [];
            let groupArray = [];
            for (let i = 0; i < this.topik.length; i++) {
              for (let grup in this.topics.formed) {
                for (let topic in this.topics.formed[grup].topics) {
                  if (this.topik[i].id == topic) {
                    topicArray.push(topic);
                    groupArray.push(grup);
                  }
                }
              }
            }
            data["new_topics"] = topicArray;
            data["new_groups"] = groupArray;
          }
          this.$http
            .post(api, data)
            .then((response) => {
              if (response.status == 200) {
                this.getData(false);
                this.is_edit = false;
              }
            })
            .catch((error) => {
              console.log(error);
            })
            .finally(() => {
              this.is_change = true;
            });
        }
      } else {
        let api = process.env.VUE_APP_API_URL + "update-stream";
        let data = {
          _id: this.post._id["$oid"],
          content: this.$sanitize(this.content),
        };
        if (this.topik.length > 0) {
          let topicArray = [];
          for (let i = 0; i < this.topik.length; i++) {
            for (let topic in this.topics.socmed) {
              if (this.topik[i].id == topic) {
                topicArray.push(topic);
              }
            }
          }
          data["new_topics"] = topicArray;
        }
        this.$http
          .post(api, data)
          .then((response) => {
            if (response.status == 200) {
              this.getData(false);
              this.is_edit_socmed = false;
            }
          })
          .finally(() => {
            this.is_change = true;
          });
      }
    },
    writeContent: function(text) {
      var newText = text;
      newText = newText.replace(/\n/g, "<br />");
      return newText;
    },
    autoHighlight() {
      let text = this.post.content;
      let keywords = [];
      if (this.post.topics) {
        for (let j in this.post.topics) {
          const topic_id = this.post.topics[j].$oid;
          if (
            this.keyword &&
            this.keyword[topic_id] &&
            this.keyword[topic_id]["keywords"]
          ) {
            keywords = [...keywords, ...this.keyword[topic_id]["keywords"]];
          }
        }
        this.post.content = this.markString(text, keywords);
      }
    },
    showFullContent: function(event, index) {
      var contentEl = $(event.target).prev();
      var text = $(event.target)
        .prev()
        .text();
      if (text.length <= this.stringLimit) {
        text = this.statement[index].quote;
        $(event.target).html(" Sembunyikan");
      } else {
        text = this.statement[index].quote.substring(0, this.stringLimit);
        $(event.target).html(" Selengkapnya");
      }
      contentEl.html(text);
    },
    hideFullContent: function(event) {
      var post_text_content = $(event.target).find(".statement-text-content");
      post_text_content.css("-webkit-line-clamp", "2");
    },
    cekString: function(text) {
      if (text.length > this.stringLimit) {
        return true;
      } else {
        return false;
      }
    },
    writeStatement: function(text) {
      var batasKata = this.stringLimit;
      var newText = text.substring(0, batasKata);
      return newText;
    },
  },
  filters: {
    showPicture: function(post) {
      let pro_pic;
      switch (post.source) {
        case "twitter":
          pro_pic = post.profile_image;
          break;
        case "instagram":
          pro_pic = post.profile_image;
          break;
        case "facebook":
          pro_pic = post.profile_photo;
          break;
        case "youtube":
          pro_pic = post.thumbnail;
          break;
        case "linkedin":
          pro_pic = post.profile_picture;
          break;
        case "tiktok":
          pro_pic = post.profile_picture;
          break;
        default:
          pro_pic = "/assets/img/profiles/default.png";
          break;
      }

      if (pro_pic == null) {
        pro_pic = "/assets/img/profiles/default.png";
      }
      return pro_pic;
    },
    kmbFormatter: function(number) {
      return gp.kmbFormatter(number);
    },
  },
  computed: {
    file_source: function() {
      let file_source = "no-video";
      let our_domain = "https://dev-kurasi.nyc3.digitaloceanspaces.com/jpgs/";
      let domain;
      if (this.post.source == "media_cetak") {
        domain = "https://pdf.antara-insight.id/pdf_images/";
      } else {
        domain = "https://";
      }
      switch (this.post.source) {
        case "media_tv":
          if (this.post.data_source == "factory") {
            if (this.post.file_source_type == "full_url") {
              file_source = this.post.file_source;
            } else {
              let filepart = this.post.file_source.split("-");
              let file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.post.file_source;
              file_source = file_src;
            }
          } else if (this.post.data_source == "siputra-etl") {
            let file_src;
            if (this.post.file_source[0].includes("https")) {
              file_src = this.post.file_source[0];
            } else {
              let filepart = this.post.file_source[0].split("-");
              file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.post.file_source[0];
            }
            file_source = file_src;
          } else {
            let file_src;
            if (this.post.file_source.includes("https")) {
              file_src = this.post.file_source;
            } else {
              let filepart = this.post.file_source.split("-");
              file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.post.file_source;
            }
            file_source = file_src;
          }
          break;

        case "media_cetak":
          if ("data_source" in this.post) {
            if (this.post.data_source == "dgv") {
              let filepart = this.post.file_source.split("-");
              let file_src =
                domain +
                filepart[0] +
                "/" +
                filepart[1] +
                "/" +
                filepart[2] +
                "/" +
                this.post.file_source;
              file_source = file_src;
            } else if (this.post.data_source == "siputra") {
              file_source = our_domain + this.post.file_source;
            } else {
              file_source = our_domain + this.post.file_source;
            }
          } else {
            file_source = our_domain + this.post.file_source;
          }

          break;

        default:
          break;
      }
      return file_source;
    },
    isAdmin: function() {
      let user_role = this.$store.getters.user.role;
      if (user_role == 2 || user_role == 3) {
        return true;
      }

      return false;
    },
  },
  created: async function() {
    this.keyword = await getTopicKeyword(this.$store.getters.user.id_project);
    this.getData(true);
    this.getPers();
    this.getTopics();
    this.$.pgNotification = notif;
    this.getTopic();
  },
  mounted: function() {
    $("#modal").modal("show");
  },
};
</script>

<style scoped>
@import "../../../../public/assets/plugins/bootstrap-social/bootstrap-social.css";
.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 3px #eee solid;
  max-height: 50px;
  max-width: 50px;
}
.perpage-el {
  padding: 0px;
}
.perpage-el i {
  font-size: 18px;
}
.text-content {
  text-align: justify;
}
.form-sorting-post {
  font-size: 12px;
  cursor: pointer;
  background-color: #fff;
  background-image: none;
  border: 1px solid rgba(33, 33, 33, 0.14);
  border-top-color: rgba(33, 33, 33, 0.21);
  font-family: -apple-system, BlinkMacSystemFont, "Inter UI", "Segoe UI",
    "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans",
    "Helvetica Neue", sans-serif, sans-serif;
  -webkit-appearance: button;
  color: #212121;
  outline: 0;
  padding: 6px 8px;
  line-height: 16px;
  font-size: 14px;
  font-weight: normal;
  vertical-align: middle;
  min-height: 32px;
  -webkit-transition: all 0.12s ease;
  transition: all 0.12s ease;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -webkit-transition: background 0.2s linear 0s;
  transition: background 0.2s linear 0s;
}
.input-group-text {
  font-size: 12px;
}
.post-items {
  margin-bottom: 20px;
}
.select2-container {
  z-index: 1 !important;
}
.user-pic {
  width: 100% !important;
  height: auto !important;
  position: relative;
}
.img-circle {
  height: auto !important;
  width: 100% !important;
  border-radius: 50%;
  border: 2px #ccc solid;
  max-height: 60px;
  max-width: 60px;
}
.twitter-border {
  border: 2px solid skyblue;
}
.post-action {
  display: block;
}
.select-sentimen {
  background: none;
  border-radius: 3px;
  font-size: 12px;
  padding: 1px 5px;
  font-weight: bold;
  opacity: 1 !important;
  cursor: pointer;
}
.sentimen1 {
  border-color: #28a745;
  color: #28a745;
}
.sentimen-1 {
  border-color: #dc3545;
  color: #dc3545;
}
.sentimen0 {
  border-color: #0e6d87;
  color: #0e6d87;
}
.emotion0 {
  border-color: #343a40;
  color: #343a40;
}
.emotion1 {
  border-color: #28a745;
  color: #28a745;
}
.emotion2 {
  border-color: #ffc107;
  color: #ffc107;
}
.emotion3 {
  border-color: #0e6d87;
  color: #0e6d87;
}
.emotion4 {
  border-color: #dc3545;
  color: #dc3545;
}
.propic-badge {
  position: absolute;
  right: 15%;
  bottom: 0px;
  font-size: 12px;
  background: white;
  border-radius: 50%;
  border: 2px #eee solid;
  padding: 1px;
  height: 25px;
  width: 25px;
  max-width: 100%;
}
.active {
  background: #0f8ff9 !important;
  color: #fff !important;
}
a:hover {
  color: blue !important;
  opacity: 1 !important;
}
#action-tersembunyi {
  display: none;
}
@media (max-width: 600px) {
  .propic-badge {
    position: absolute;
    right: 40%;
    top: 40px;
    font-size: 14px;
    background: white;
    border-radius: 50%;
    border: 1px #eee solid;
    padding: 2px 1px;
    height: 25px;
    width: 25px;
  }
}
select:after {
  content: " ";
  display: inline-block;
  width: 24px;
  height: 24px;
  background: blue;
}
.emot-wrapper {
  float: left;
  margin: 0px 5px;
  cursor: pointer;
}
.emot-wrapper:hover p {
  color: #0f8ff9 !important;
}
.emot-wrapper:hover a {
  color: #0f8ff9 !important;
}
select {
  cursor: pointer;
}
.post-text-content {
  padding-left: 5px;
}
#content {
  min-height: 100px;
  max-height: 400px;
  overflow-y: scroll;
}
.modal.fade.fill-in > .close > i {
  font-size: 60px;
}
.modal-lebar {
  width: 70% !important;
}
.avatar {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  height: 100% !important;
}
.source {
  background-color: #f8f8ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 5.5rem;
  height: 5.5rem;
}
.editor {
  height: 225px;
}
</style>
